import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

const baseURI = 'nominas/descuentos-asignaciones-masivas';
const reportesURI = 'nominas/descargar-reporte-descuento-masivo';

/**
 * GET Descuentos Asignación Masiva
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getDescuentosAsignacionMasiva = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Descuento Asignación Masiva
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getDescuentoAsignacionMasiva = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Descuento Asignación Masiva
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postDescuentoAsignacionMasiva = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * PATCH Descuento Asignación Masiva
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchDescuentoAsignacionMasiva = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * DELETE Descuento Asignación Masiva
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteDescuentoAsignacionMasiva = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * PATCH Autorizar Descuento Asignación Masiva
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarDescuentoAsignacionMasiva = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * GET Descargar Descuentos Activos del Descuento Asignación Masiva
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const descargarReporteDescuentosActivos = async (id) => {
  try {
    const response = await API.get(`${reportesURI}/${id}/activos`, {
      headers: {
        'Content-Type': 'application/pdf',
      },
      responseType: 'arraybuffer',
    });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * GET Descargar Descuentos de Suspensión Definitiva o Temporal del Descuento Asignación Masiva
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const descargarReporteDescuentosSuspendidos = async (id) => {
  try {
    const response = await API.get(`${reportesURI}/${id}/suspendidos`, {
      headers: {
        'Content-Type': 'application/pdf',
      },
      responseType: 'arraybuffer',
    });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * PUT Eliminar Descuentos Asignacion Masiva
 * @param {object} values
 * @returns {Promise<{}>}
 */
export const eliminarDescuentosAsignacionMasiva = async (values) => {
  try {
    const response = await API.put('nominas/eliminar-descuento-asignacion-masiva', values);
    onSuccess(response, 'Eliminados correctamente');
    return true;
  } catch (err) {
    onError(err);
  }
  return false;
};
